/**
 * Applications API (standalone) — get, update, delete, advance, reject.
 */

import { apiFetch } from './core'

export const applications = {
    get: (id) => apiFetch(`/applications/${id}`),
    update: (id, data) => apiFetch(`/applications/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
    }),
    delete: (id) => apiFetch(`/applications/${id}`, { method: 'DELETE' }),
    advance: (id) => apiFetch(`/applications/${id}/advance`, { method: 'POST' }),
    reject: (id, reason = '') => apiFetch(`/applications/${id}/reject`, {
        method: 'POST',
        body: JSON.stringify({ reason }),
    }),
    history: (id) => apiFetch(`/applications/${id}/history`),
}
